import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { toast } from 'react-toastify';

export const addStudentScholarshipOperation = async (
  userId: number,
  scholarshipSum: number,
  funderId: number,
  setIsLoading: (loading: boolean) => any,
  closeDialog: () => any,
) => {
  if (scholarshipSum <= 0) {
    toast.warn('סכום המלגה חייב להיות גדול מ-0');
    return;
  }

  setIsLoading(true);
  try {
    const response = await appApi.addStudentScholarship(
      userId,
      scholarshipSum,
      funderId,
    );

    if (!response.data.ok) {
      toast.error('יצירת המלגה נכשלה');
      return;
    }

    toast.success('המלגה נוספה בהצלחה');

    // Refresh student details to include the new scholarship
    const updatedUserDetails = await appApi.getUserStudentDetails(userId);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    closeDialog();
  } catch (error) {
    console.error(`addStudentScholarshipOperation failed with error: ${error}`);
    toast.error('אירעה שגיאה בעת יצירת המלגה');
  } finally {
    setIsLoading(false);
  }
};
